import React from "react";
import { Table } from "react-bootstrap";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { IThermogram } from "../model/thermogram.model";

interface ThermogramMetaDataTableProps {
    thermogram: IThermogram;
    audio?: string | null;
    tempRef?: number | null;
    deltaT?: number;
}

const ThermogramMetaDataTable = ({
    thermogram,
    audio,
    tempRef = 0,
    deltaT = 0,
}: ThermogramMetaDataTableProps) => {
    const { t } = useTranslation();
    const tt = (key: string, options?: Record<string, unknown>) => t(key, { ns: "translation", ...options });

    return (
        <Table striped bordered hover className="table-thermography">
            <tbody>
                {audio && (
                    <tr>
                        <td className="fw-bold p-5 align-items-center" colSpan={2}>
                            <div className="d-flex align-items-center">
                                <span className="me-3">{tt("pages.thermography.thermogramMetaDataTable.audio")}</span>
                                <div className="audio-player-container">
                                    <audio
                                        controls
                                        src={audio}
                                        style={{ height: "25px", padding: 0 }}
                                    />
                                </div>
                            </div>
                        </td>
                    </tr>
                )}

                <tr>
                    <td className="fw-bold p-5">
                        {tt("pages.thermography.thermogramMetaDataTable.objectTemperature")}
                    </td>
                    <td className="fw-bold p-5">

                        {thermogram.maxTempRoi ? Number(thermogram.maxTempRoi).toFixed(1)  : Number(thermogram.maxTemp).toFixed(1)} °C
                    </td>
                </tr>

                <tr>
                    <td className="fw-bold p-5">
                        {tt("pages.thermography.thermogramMetaDataTable.referenceTemperature")}
                    </td>
                    <td className="fw-bold p-5">{Number(tempRef).toFixed(1)} °C</td>
                </tr>

                <tr>
                    <td className="text-danger fw-bold p-5">
                        {tt("pages.thermography.thermogramMetaDataTable.temperatureDifference")}
                    </td>
                    <td className="text-danger fw-bold p-5">{Number(deltaT).toFixed(1)} °C</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.emissivity")}</td>
                    <td>{Number(thermogram.emissivity).toFixed(2)}</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.distance")}</td>

                    <td>{Number(thermogram.subjectDistance).toFixed(1)} m</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.reflectedTemperature")}</td>

                    <td>{Number(thermogram.reflectedTemp).toFixed(1)} °C</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.ambientTemperature")}</td>
                    <td>{Number(thermogram.atmosphericTemp).toFixed(1)} °C</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.relativeHumidity")}</td>
                    <td>{Number(thermogram.relativeHumidity).toFixed(1)} %</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.recordDateTime")}</td>
                    <td>
                        {thermogram.createdAt
                            ? dayjs(thermogram.createdAt, "YYYY:MM:DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
                            : tt("pages.thermography.thermogramMetaDataTable.notAvailable")}
                    </td>
                </tr>

                {/* <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.windSpeed")}</td>
                    <td> m/s</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.load")}</td>
                    <td> kA</td>
                </tr> */}

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.camera")}</td>
                    <td>{thermogram.cameraModel}</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.resolution")}</td>
                    <td>{thermogram.imageResolution}</td>
                </tr>

                <tr>
                    <td>{tt("pages.thermography.thermogramMetaDataTable.lens")}</td>
                    <td>{thermogram.cameraLens}°</td>
                </tr>

                {/* <tr>
                    <td>Latitude</td>
                    <td>{thermogram.latitude}</td>
                </tr>

                <tr>
                    <td>Longitude</td>
                    <td>{thermogram.longitude}</td>
                </tr> */}
            </tbody>
        </Table>
    );
};

export default ThermogramMetaDataTable;
